import { ChangeEvent, forwardRef, useEffect, useState } from 'react';
import { Icons } from '../icons/icons';

type Props2 = {
  name: string;
  value: string;
  label?: string;
  defaultChecked?: boolean;
  currentValue: string;
  hideLabel?: boolean;
  onChange(event: ChangeEvent<HTMLInputElement>): void;
  onBlur(event: ChangeEvent<HTMLInputElement>): void;
};

export const Radio = forwardRef((props: Props2, ref: any): JSX.Element => {
  const [checked, setChecked] = useState<boolean>(false);
  const { currentValue, hideLabel, ...otherProps } = props;

  useEffect(() => {
    setChecked(currentValue === props.value);
  }, [currentValue]);

  return (
    <div className="checkbox-container">
      <span className="checkbox">
        <input type="radio" id={props.value} {...otherProps} ref={ref} checked={checked} />
        {checked ? <Icons.RadioButtonSelected /> : <Icons.RadioButton />}
      </span>
      {!hideLabel && (
        <label htmlFor={props.value} className="form-label">
          {props.label ? props.label : props.value[0]?.toUpperCase() + props.value.slice(1)}
        </label>
      )}
    </div>
  );
});
